export default __webpack_public_path__ + "static/eit-e797c6a369a10edc7d05aa3c4767a1e9.png";